<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <EffectTypeForm
      v-if="!isLoading"
      :effectTypeData="effectTypeData"
      :submitName="$t('edit')"
      v-on:addOrUpdateEffectType="updateEffectType"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import EffectTypeForm from "@/components/settings/settingsOther/effectTypes/EffectTypeForm.vue";
import EffectType from "@/models/settings/settingsOther/effectTypes/EffectType";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "EffectTypeEdit",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    EffectTypeForm,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      effectTypeData: new EffectType(),
      additionalEffectTypeToken: this.$route.params.additionalEffectTypeToken,
    };
  },
  methods: {
    async getEffectTypeDetails() {
      this.isLoading = true;
      this.effectTypeData.additionalEffectTypeToken =
        this.additionalEffectTypeToken;
      try {
        let response = await this.effectTypeData.getEffectTypeDetails(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.effectTypeData.fillData(response.data.additionalEffectTypeData);
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
          this.effectTypeData = null;
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.effectTypeData = null;
      }
      this.isLoading = false;
    },
    async updateEffectType() {
      this.isLoading = true;
      try {
        let response = await this.effectTypeData.addOrUpdateEffectType(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push("/effect-types");
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getEffectTypeDetails();
  },
};
</script>

<style scoped lang="scss"></style>
